function triggerEvent(data) {
  if (typeof window.dataLayer === 'undefined') {
    window.dataLayer = [];
  }
  switch (data.type) {
    case '':
      window.dataLayer.push(data.data);
      break;
    default:
      window.dataLayer.push(data.data);
      break;
  }
}
export { triggerEvent as default };
